import type { HtmlBlock } from '@blogforge/shared';
import type { DragPath } from '../../types';
import { useEditorStore } from '../../stores/editorStore';
import { CodeEditor } from './Input';

interface HtmlBlockInspectorProps {
  block: HtmlBlock;
  path: DragPath;
}

export function HtmlBlockInspector({ block, path }: HtmlBlockInspectorProps) {
  const updateBlock = useEditorStore((s) => s.updateBlock);

  return (
    <div className="space-y-6">
      <CodeEditor
        label="HTML"
        value={block.content}
        onChange={(v) =>
          updateBlock(
            block.id,
            {
              content: v,
            },
            path,
          )
        }
      />

      <CodeEditor
        value={block.attrs?.cssStr || ''}
        label="Custom CSS"
        helper="Enter styles relevant to pasted html"
        language="css"
        onChange={(value) => updateBlock(block.id, { attrs: { cssStr: value || undefined } }, path)}
      />
    </div>
  );
}
